import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import ResetToDefaultButton from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/ResetToDefaultButton/ResetToDefaultButton'

import AppearanceColorField from '../AppearanceColorField/AppearanceColorField'
import { widgetPreviewViews } from '../constants'
import { getFieldError } from '../helpers'
import SectionIntro from '../SectionIntro/SectionIntro'
import WidgetPreview from '../WidgetPreview/WidgetPreview'
import * as Styles from './styles'

const WidgetBlock = ({ appearance, fieldErrors, onChangeColor, onReset, resetting, disabled, resetDisabled }) => {
  const { t } = useTranslation()

  return (
    <Styles.Block>
      <SectionIntro
        title={t('Widget')}
        description={t(
          'Personaliza cómo se ve el widget de Return Protection para que encaje con el branding de tu tienda.'
        )}
      >
        <Alert type="info">{t('Los textos no se pueden personalizar en esta versión.')}</Alert>
      </SectionIntro>
      <Styles.Content>
        <Styles.Fields>
          <AppearanceColorField
            field="widget_background_color"
            label={t('Color de fondo')}
            recommendation={t('Se aplica al fondo del widget')}
            color={appearance.widget_background_color}
            error={getFieldError(fieldErrors, 'widget_background_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <AppearanceColorField
            field="widget_text_color"
            label={t('Color de texto')}
            recommendation={t('Se aplica al texto y los iconos')}
            color={appearance.widget_text_color}
            contrastColor={appearance.widget_background_color}
            error={getFieldError(fieldErrors, 'widget_text_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <AppearanceColorField
            field="widget_link_color"
            label={t('Color de enlace')}
            recommendation={t('Se aplica al enlace')}
            color={appearance.widget_link_color}
            contrastColor={appearance.widget_background_color}
            error={getFieldError(fieldErrors, 'widget_link_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <ResetToDefaultButton onClick={onReset} loading={resetting} disabled={resetDisabled} />
        </Styles.Fields>
        <Styles.Preview>
          <WidgetPreview view={widgetPreviewViews.widget} appearance={appearance} />
        </Styles.Preview>
      </Styles.Content>
    </Styles.Block>
  )
}

export default WidgetBlock
